<template>
  <div :style="loginStyle">
    <router-view></router-view>
  </div>
</template>

<script>
import bg from '@/assets/login/bg.png'
import { getAction } from '@/api/manage'
export default {
  name: 'UserLayout',
  data () {
    return {
      loginStyle: {
        background: `url(${bg})`,
        backgroundSize: '100% 100%',
        height: '100%',
        backgroundRepeat: 'no-repeat'
      }
    }
  },
  created () {
    //个性化首页和logo标识
    if(myPersonalizationSetData == null) {
      let wPath = window.location.href;
      getAction("/show/personalization/queryByPath", { 'path': wPath }).then((res) => {
        if (res.success) {
          //console.log(res.result);
          if (res.result) {
            myPersonalizationSetData = res.result;
          } else {
            myPersonalizationSetData = defaultPersonalizationSetData;
          }
        } else {
          myPersonalizationSetData = defaultPersonalizationSetData;
        }
        this.loginStyle.background = 'url(' + myPersonalizationSetData.indexBg + ')';
      });
    }else{
      this.loginStyle.background = 'url(' + myPersonalizationSetData.indexBg + ')';
    }
  },
}
</script>

<style lang='less' scoped>
</style>
